module.exports = __webpack_public_path__ + "static/media/noRider.894f9586.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/noRider.png
// module id = 161
// module chunks = 2